module.exports = ".btn-load-file {\n  text-decoration: underline;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-main/components/user-application-dialog/user-application-dialog.component.scss
// module id = ./src/app/modules/common-main/components/user-application-dialog/user-application-dialog.component.scss
// module chunks = main